import React,{useRef, useState, useEffect} from "react";
import { Card, Row, Col, InputGroup, Form, Button} from "react-bootstrap";
import atlasApi from "../utils/atlasapi";

const bufferTimer = 200; //keyboard input tolerance timer before fetching content

class DataTableFilter extends React.Component {

	
	constructor(props) {
		
		super(props);


		
		this.wrp = React.createRef();

		this.lastCall = null;
	}

	handleOnchange(e){
		
		
		if(this.props.onChange){
			this.props.onChange(e.target.value ? e.target.value : '');
		}
		if(e.target.value){
			this.wrp.current.classList.add("active");
		}
		else 
			this.wrp.current.classList.remove("active");
		
	};
	handleReset(e){
		this.wrp.current.querySelector("INPUT").value = '';
		this.handleOnchange(e);
	}
	
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
	}


	render() {
		return (
			<div ref={this.wrp} className={"datatable-filter " + (this.props.value ? 'active' : '')}>
				<i className="ri-search-line"></i>
				<input onChange={(e)=>{this.handleOnchange(e)}} value={this.props.value} placeholder="Search..." />
				<i className="ri-close-line" value="" onClick={(e)=>{this.handleReset(e)}}></i>
			</div>
		);
	}
}

export default DataTableFilter;